<template>
  <div class="permission-content">
    <div class="header">
      <div class="title">成员与权限</div>
    </div>
    <div class="search">
      <el-form inline class="inline-form" :model="searchForm" label-width="80px" label-position="left">
        <el-form-item label="手机号">
          <el-input v-model="searchForm.mobile" placeholder="请输入手机号" size="small"/>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="searchForm.userName" placeholder="请输入账号" size="small"/>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="searchForm.operateName" placeholder="请输入姓名" size="small"/>
        </el-form-item>
        <el-button type="primary" @click="newMember" class="btn-base bs-btn">创建成员</el-button>
        <el-button type="primary" @click="search" class="btn-base search-btn bs-btn">查询</el-button>
      </el-form>
    </div>
    <div class="table-list">
      <div class="table-content">
        <el-table :data="tableData" style="width: 100%;" border v-loading="loadingTable">
          <el-table-column prop="operatorName" label="姓名" align="center"/>
          <el-table-column prop="userName" label="账号" align="center"/>
          <el-table-column prop="mobile" label="手机号" align="center"/>
          <el-table-column prop="merchantName" label="门店" align="center"/>
          <el-table-column prop="remark" label="备注" align="center"/>
          <el-table-column label="操作" align="center">
            <template slot-scope="{row}">
              <el-button class="table-btn" type="primary" @click="deleteUser(row)" v-show="row.status === 0">注销</el-button>
              <el-button class="table-btn" type="primary" v-show="row.status === 2" style="color: #ccc;">已注销</el-button>
              <el-button
                class="table-btn set"
                type="primary"
                @click="modifyDetail(row)"
                :disabled="row.status === 2"
                style="color: #ffa11b;"
                :class="{'modify-btn': row.status === 2}">修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"/>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
import { listBackstageUserInfo, cancelBackstageUserInfo } from "@/api/member-permisson";

export default {
  name: "member-permisson",
  data() {
    return {
      searchForm: {
        mobile: "",
        userName: "",
        operateName: "",
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      tableData: [],
      loadingTable: false,
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    modifyDetail(row) {
      localStorage.setItem("memberInfo", JSON.stringify(row));
      this.$router.push("/member-permisson/modifyInfo");
    },
    newMember() {
      localStorage.setItem("memberInfo", JSON.stringify({}));
      this.$router.push("/member-permisson/modifyInfo");
    },
    deleteUser(row) {
      this.$confirm("删除账号后，此成员将不能使用此账号登录后台，并不可进行信息修改，确定要注销账号吗？", "注销账号", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        cancelButtonClass: 'bs-btn2',
        confirmButtonClass: 'bs-btn',
      }).then(() => {
        const params = { userName: row.userName };
        cancelBackstageUserInfo(params).then((res) => {
          if (res.data.error_code === 0) {
            this.$message.success('操作成功');
            this.queryData();
          }
        });
      });
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryData();
    },
    search() {
      this.page.pageNo = 1;
      this.queryData();
    },
    queryData() {
      const params = Object.assign(this.searchForm, this.page);
      this.loadingTable = true;
      listBackstageUserInfo(params).then((res) => {
        this.loadingTable = false;
        if (res.data.error_code === 0) {
          this.tableData = res.data.data.list;
          if (this.tableData.length > 0) {
            this.tableData.forEach((e1) => {
              e1.merchantName = e1.merchantList.map(e2 => e2.merchantName);
              e1.merchantName = e1.merchantName.join('，');
            });
          }
          this.page.count = res.data.data.totalCount;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.permission-content {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search {
    padding: 40px 50px 20px;

    .btn-base {
      float: right;
      width: 90px;
      height: 32px;
      padding: 0;
      line-height: 0px;
    }

    .search-btn {
      margin-right: 10px;
    }

    .el-form-item {
      margin-right: 40px;
    }

    .el-form--inline .el-form-item__label {
      min-width: 80px;
      font-size: 14px;
      font-weight: 400;
      color: #333;

      .el-form-item__content {
        overflow: hidden;
      }
    }
  }

  .table-list {
    overflow: hidden;
    background: #f7f7f7;

    .table-content {
      padding: 40px 50px;
      overflow: hidden;
      background: #fff;
      border-top: 20px solid #eee;

      .table-btn {
        width: 60px;
        height: 25px;
        padding: 0;
        margin: 0 10px 0 0;
        color: #1395ff;
        cursor: pointer;
        background: transparent;
        border: none;

        &.set {
          color: #ffa11b;
        }
      }

      .modify-btn {
        color: #ccc !important;
      }
    }
  }
}
</style>
